//
//  BasicScreeningResults Actions
//  CXA Apollo
//
//  Created on 07/12/2016.
//  Copyright (c) 2016 CXA. All rights reserved.
//
//  payloads of information that send data to our store.
//

import api from "../api/flexapi";

/*
Specify any custom actions in a format:
export const basicScreeningResultsActionName = "screeningResultsActionName";
*/

// Type of action being performed
export const basicScreeningResultsLoadBegin = "basicScreeningResultsLoadBegin";
export const basicScreeningResultsLoadSuccess =
  "basicScreeningResultsLoadSuccess";
export const basicScreeningResultsLoadFailed =
  "basicScreeningResultsLoadFailed";

export const basicScreeningResultsPrintLoadBegin =
  "basicScreeningResultsPrintLoadBegin";
export const basicScreeningResultsPrintLoadSuccess =
  "basicScreeningResultsPrintLoadSuccess";
export const basicScreeningResultsPrintLoadFailed =
  "basicScreeningResultsPrintLoadFailed";

// Call API to load module data
export function load() {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: basicScreeningResultsLoadBegin, payload: null });

    api
      .getBasicScreeningResults()
      .then(response => {
        dispatch({
          type: basicScreeningResultsLoadSuccess,
          payload: response.body,
        });
      })
      .catch(err => {
        dispatch({
          type: basicScreeningResultsLoadFailed,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

// Call API to load module data
export function loadToPrint() {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: basicScreeningResultsPrintLoadBegin, payload: null });

    // api.dummyApiCall({ type: "print-screening" }).then(response => {
    //   dispatch({ type: basicScreeningResultsPrintLoadSuccess, payload: response.body });
    // }).catch(err => {
    //   dispatch({ type: basicScreeningResultsPrintLoadFailed, payload: err.response ? err.response.body : err });
    // });
    api
      .getBasicScreeningResultsToPrint()
      .then(response => {
        dispatch({
          type: basicScreeningResultsPrintLoadSuccess,
          payload: response.body,
        });
      })
      .catch(err => {
        dispatch({
          type: basicScreeningResultsPrintLoadFailed,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./actions/basicScreeningResultsActions.jsx